import React from 'react'
import Navbar from '../Navbar/Navbar'
import Footer from '../Footer/Footer'
import ContactForm from '../ContactUs/ContactForm'
import TrustedPartner from './TrustedPartner/TrustedPartner'
import CompanyLogo from './CompanyLogo/CompanyLogo'
import HeroSection from './HeroSection/HeroSection'

const Partnerships = () => {
    return (
        <>
            <Navbar />
            <HeroSection />
            <CompanyLogo />
            <TrustedPartner />
            <ContactForm />
            <Footer />
        </>
    )
}

export default Partnerships